import { REVIEWS_USERS_FILTERS } from './RatingsUsersFilter/RatingsUsersFilter.helpers';

export const REVIEWS_USERS_FILTERS_DEFAULT_KEY = REVIEWS_USERS_FILTERS[0].key;

export const SET_HAS_MORE = 'RATINGS/SET_HAS_MORE';
export const setHasMore = hasMore => ({ type: SET_HAS_MORE, hasMore });

export const SET_CURRENT_PAGE = 'RATINGS/SET_CURRENT_PAGE';
export const setCurrentPage = currentPage => ({
  type: SET_CURRENT_PAGE,
  currentPage,
});

export const SET_RATINGS_USERS_FILTER = 'RATINGS/SET_RATINGS_USERS_FILTER';
export const setRatingsUserFilter = key => ({ type: SET_RATINGS_USERS_FILTER, key });

export const SET_SELECTED_CLASS = 'RATINGS/SET_SELECTED_CLASS';
export const setSelectedClass = classId => ({ type: SET_SELECTED_CLASS, classId });

export const SET_SELECTED_INSTRUCTOR = 'RATINGS/SET_SELECTED_INSTRUCTOR';
export const setSelectedInstructor = instructorId => ({ type: SET_SELECTED_INSTRUCTOR, instructorId });

export const RESET_FILTERS = 'RATINGS/RESET_FILTERS';
export const resetFilters = () => ({ type: RESET_FILTERS });

export const SET_SHOULD_REFRESH_RATINGS_LIST = 'RATINGS/SET_SHOULD_REFRESH_RATINGS_LIST';
export const setShouldRefreshRatingsList = shouldRefreshRatingsList => ({
  type: SET_SHOULD_REFRESH_RATINGS_LIST,
  shouldRefreshRatingsList,
});

export const SET_SELECTED_TAB = 'RATINGS/SET_SELECTED_TAB';
export const setSelectedTab = tab => ({ type: SET_SELECTED_TAB, tab });

export const initialState = {
  currentPage: 0,
  hasMore: false,
  selectedUsersFilterKey: REVIEWS_USERS_FILTERS_DEFAULT_KEY,
  selectedClassId: null,
  selectedInstructorId: null,
  shouldRefreshRatingsList: true,
  selectedTab: 'overview',
};

export default (state = initialState, action) => {
  const { type, hasMore, currentPage, key, classId, instructorId, shouldRefreshRatingsList, tab } = action;

  switch (type) {
    case SET_HAS_MORE:
      return { ...state, hasMore };
    case SET_CURRENT_PAGE:
      return { ...state, currentPage };
    case SET_RATINGS_USERS_FILTER:
      return { ...state, selectedUsersFilterKey: key };
    case SET_SELECTED_CLASS:
      return { ...state, selectedClassId: classId };
    case SET_SELECTED_INSTRUCTOR:
      return { ...state, selectedInstructorId: instructorId };
    case RESET_FILTERS:
      return {
        ...state,
        selectedUsersFilterKey: initialState.selectedUsersFilterKey,
        selectedClassId: initialState.selectedClassId,
        selectedInstructorId: initialState.selectedInstructorId,
      };
    case SET_SHOULD_REFRESH_RATINGS_LIST:
      return { ...state, shouldRefreshRatingsList };
    case SET_SELECTED_TAB:
      return { ...state, selectedTab: tab };
    default:
      return state;
  }
};
